import React, { useState, useEffect } from 'react'
import { TopBarSection, TopBarTitle, WidgetContent, TopBar } from '@duik/it'
import MainContainer from '../../UI/MainContainer'
import TableContainer from '../../UI/TableContainer'
import TableSection from '../../UI/TableSection'
import TableHeader from '../../UI/TableHeader'
import TopBarMenuDivider from '../../UI/TopBarMenuDivider'
import DownloadCSVIcon from '@material-ui/icons/SaveAltOutlined'
import moment from 'moment'
import EditLoadModal from './EditLoadModal'
//TODO: Update below components to new UI library once they're being used
// import EditLoadSlipModal from './EditLoadSlipModal'
// import EditLoadModalCement from './EditLoadModalCement'
// import LoadItemBackup from './LoadItemBackup'
// import LoadMultiUpdateModal from './LoadMultiUpdateModal'
import ViewNotesModal from './ViewNotesModal'
import { saveAs } from 'file-saver'
import { Link } from 'react-router-dom'
import LoadItem from './LoadItem'
import { useLoadActionModal, useDeleteLoadModal } from 'Hauls/Shared/hooks'
import LoadActionModal from './LoadActionModal'
import LoadDeleteModal from './LoadDeleteModal'
import { AnalyticEvent } from 'analytics/GoogleAnalytics'
import LoadingIcon from '../../components/LoadingIcon'
import { api } from '../../Controllers/api'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { setSnackBarCopy, toggleSnackBar } from '../../UI/Store/actions'
import { StyledSyncIconButton } from '../../Projects/Styles/projects'
import { getToken } from 'Companies/Store/actions'
import SmBannerModal from 'UI/SmBannerModal'
import SyncIcon from '@material-ui/icons/Sync'
import DownloadIconButton from 'UI/DownloadIconButton'

const { Parser } = require('json2csv')

const Loads = props => {
  const [loadList, setLoadList] = useState(null)
  const [material, setMaterial] = useState()
  const [loading, setLoading] = useState(true)
  const [loadingLoads, setLoadingLoads] = useState(true)
  const [loadView] = useState('default')
  const [editLoadModal, setEditLoadModal] = useState(false)
  // const [editLoadSlipModal, setEditLoadSlipModal] = useState(false)
  // const [editLoadModalCement, setEditLoadModalCement] = useState(false)
  const [viewNotesModal, setViewNotesModal] = useState(false)
  const [editLoadDetail, setEditLoadDetail] = useState()
  // const [editLoadSlipDetail, setEditLoadSlipDetail] = useState()
  const [haulDetail, setHaulDetail] = useState()
  const { loadActionModal, handleLoadActionModal, loadAction, setLoadAction } = useLoadActionModal()
  const [loadDeleteDetail, setLoadDeleteDetail] = useState()
  const { loadDeleteModal, handleDeleteLoadModal } = useDeleteLoadModal()
  const [loadMultiUpdateModal, setLoadMultiUpdateModal] = useState(false)
  const [multiEditDetail, setMultiEditDetail] = useState()
  const [modalVisible, setModalVisible] = useState(false)
  const [procoreSyncing, setProcoreSyncing] = useState(false)
  const [procoreError, setProcoreError] = useState(false)

  const csvExport = () => {
    const fields = [
      { value: 'haulId', label: 'Haul ID' },
      { value: 'projectName', label: 'Project Name' },
      { value: 'material', label: 'Material' },
      {
        value: row => moment(row.arriveTimeA).format('MMMM D YYYY, HH:mm'),
        label: haulDetail.pickUpSite.siteName + ' Arrival Time'
      },
      {
        value: row => moment(row.departTimeA).format('MMMM D YYYY, HH:mm'),
        label: haulDetail.pickUpSite.siteName + ' Depart Time'
      },
      {
        value: row => moment(row.arriveTimeB).format('MMMM D YYYY, HH:mm'),
        label: haulDetail.dropOffSite.siteName + ' Arrival Time'
      },
      {
        value: row => moment(row.departTimeB).format('MMMM D YYYY, HH:mm'),
        label: haulDetail.dropOffSite.siteName + ' Depart Time'
      },
      { value: 'driver.firstName', label: 'Driver First Name' },
      { value: 'driver.lastName', label: 'Driver Last Name' },
      { value: 'driver.companyName', label: 'Driver Company Name' },
      { value: 'driver.truckId', label: 'Driver Truck ID' },
      { value: 'driver.truckType', label: 'Driver Truck Type' },
      { value: 'quantity', label: 'Volume' },
      { value: 'pitGrossWeight', label: 'Gross Weight' },
      { value: 'pitNetWeight', label: 'Net Weight' },
      { value: 'pitTareWeight', label: 'Tare Weight' },
      { value: 'pitLocationNumber', label: 'Pit Location Number' },
      { value: 'pitTicketNumber', label: 'Pit Slip Ticket Number' },
      { value: 'pitCompanyName', label: 'Pit Name' },
      { value: 'notes', label: 'Notes' }
    ]

    const json2csvParser = new Parser({ fields })
    let csv = json2csvParser.parse(loadList)
    // console.log(csv);
    let file = new Blob([csv], { type: 'charset=utf-8' })
    saveAs(file, `loads.csv`, { autoBom: true })
  }

  // const editLoadSlipModalToggle = _id => {
  //   if (_id) {
  //     const load = loadList.find(load => load._id === _id)
  //     setEditLoadSlipDetail(load)
  //   }
  //   setEditLoadSlipModal(!editLoadSlipModal)
  // }

  const editLoadModalToggle = _id => {
    if (_id) {
      const load = loadList.find(load => load._id === _id)
      setEditLoadDetail(load)
    }
    setEditLoadModal(!editLoadModal)
  }

  // const editLoadModalCementToggle = _id => {
  //   if (_id) {
  //     const load = loadList.find(load => load._id === _id)
  //     setEditLoadDetail(load)
  //   }
  //   setEditLoadModalCement(!editLoadModalCement)
  // }

  const viewNotesModalToggle = _id => {
    if (_id) {
      const load = loadList.find(load => load._id === _id)
      setEditLoadDetail(load)
    }
    setViewNotesModal(!viewNotesModal)
  }

  const loadDeleteModalToggle = _id => {
    const load = loadList.find(load => load._id === _id)
    setLoadDeleteDetail(load)
    handleDeleteLoadModal(!loadDeleteModal)
  }

  const loadMultiUpdateModalToggle = () => {
    setLoadMultiUpdateModal(!loadMultiUpdateModal)
  }

  const getLoads = () => {
    const authToken = localStorage.getItem('auth')
    api
      .get(`haullog/${props.match.params.id}`, {
        withCredentials: false,
        headers: { Authorization: `Bearer ${authToken}` }
      })
      .then(({ data }) => {
        setLoadList(data)
        if (data.length > 0) {
          setMaterial(data[0].material)
        }
        setLoadingLoads(false)
        setLoading(false)
      })
      .catch(error => console.log(error))
  }

  const editLoad = (_id, body) => {
    if (editLoadDetail && editLoadDetail.quantity !== body.quantity) {
      // ask to update all loads
      setMultiEditDetail(body)
      handleEditLoad(_id, body)
      loadMultiUpdateModalToggle()
    } else {
      handleEditLoad(_id, body)
    }
  }

  const handleEditLoad = (_id, body) => {
    api
      .put(`haullog/${_id}`, body, { withCredentials: false })
      .then(data => {
        getLoads()
      })
      .catch(error => {
        console.log(error)
        alert('Error updating load.')
      })
  }

  // const editLoadMulti = () => {
  //   setLoadMultiUpdateModal(false)
  //   const body = {
  //     date: editLoadDetail.arriveTimeA,
  //     truckType: editLoadDetail.driver.truckType,
  //     haulId: editLoadDetail.haulId,
  //     material: editLoadDetail.material,
  //     quantity: multiEditDetail.quantity
  //   }
  //   api
  //     .put(`haullog/multiupdate/`, body, { withCredentials: false })
  //     .then(data => {
  //       getLoads()
  //     })
  //     .catch(error => {
  //       console.log(error)
  //       alert('Error editing loads')
  //     })
  // }

  const getHaulDetails = () => {
    const haul = props.haulList.find(data => data.haulId === props.match.params.id)
    setHaulDetail(haul)
  }

  const deleteLoad = _id => {
    if (_id) {
      AnalyticEvent('Contacts', 'DeleteContactConfirmButtonPressed')
      setLoadAction('delete')
      api.delete(`haullog/${_id}`).then(data => {
        handleDeleteLoadModal(!loadDeleteModal)
        handleLoadActionModal()
        getLoads()
      })
    } else {
      handleDeleteLoadModal(!loadDeleteModal)
    }
  }

  const validateProcoreCredentials = () => {
    const { clientId, clientSecret, authToken, authTokenExpiry } = props.procore

    const tokenValid = moment().isBefore(moment(authTokenExpiry))

    if (!authToken || !tokenValid) {
      getToken(clientId, clientSecret)
    }
  }

  const handleProcoreSync = () => {
    const loadsToSync = loadList.filter(item => !item.procoreId)
    if (!loadList || loadList.length === 0 || loadsToSync.length === 0) {
      alert('No loads to sync')
      return
    }

    setModalVisible(true)
    setProcoreSyncing(true)

    const project = props.projects.find(project => project._id === haulDetail.projectId)
    const procoreCostCodeId = haulDetail.procoreCostCode.id || undefined

    if (project && project.procoreProjectId && loadsToSync.length > 0) {
      api
        .post('procore/add-quantity', {
          procoreProjectId: project.procoreProjectId,
          loads: loadsToSync,
          token: props.procore.authToken,
          procoreCostCodeId
        })
        .then(({ data }) => {
          setProcoreSyncing(false)
          getLoads()
        })
        .catch(error => {
          setProcoreError(true)
          setProcoreSyncing(false)
        })
    }
  }

  useEffect(() => {
    if (props.companyFeatures.includes('procore')) {
      validateProcoreCredentials()
    }
  }, [props.companyFeatures])

  useEffect(() => {
    getLoads()
    getHaulDetails()

    window.scrollTo(0, 0)
  }, []) //eslint-disable-line

  let count = 1
  let displayDate = false

  // const view = type => {
  //   return (
  //     <span className="haulViewTitle">
  //       View:<span className="haulViewType">{type}</span>
  //     </span>
  //   )
  // }
  return (
    <MainContainer>
      {/* <div style={{ width: '100%' }}>
        <TopBar>
          <TopBarSection>
            <Link to="/app/hauls" style={{ textDecoration: 'none' }}>
              <h2 className="top-bar-title" style={{ paddingLeft: '25px' }}>
                Hauls
              </h2>
            </Link>
            <h2 className="top-bar-title">&nbsp;{'>'}&nbsp;</h2>
            <h2 className="top-bar-title" style={{ width: 'auto' }}>
              {props.match.params.id}
            </h2>
            <h2 className="top-bar-title">&nbsp;{'>'}&nbsp;</h2>
            <h2 className="top-bar-title">Loads</h2>
          </TopBarSection>
          <UikTopBarSection className={cls.actions}>
            <UikInput
              iconPosition="right"
              placeholder="Search"
              icon={<SearchIcon />}
              className="halfWidthInputBox"
              wrapperProps={{ style: { marginRight: '10px' } }}
              disabled
            />
            <UikButton className={[cls.goPremiumBtn, 'newButton']} success>
              <AddCircleIcon style={{ paddingRight: '9px' }} /> New Haul
            </UikButton>
          </UikTopBarSection>
        </TopBar>
      </div> */}

      <TableContainer>
        <WidgetContent style={{ padding: '8px 0px' }} className="uik-widget-content__wrapper">
          <TopBarSection style={{ padding: '0 30px' }}>
            <TopBarTitle>Loads</TopBarTitle>
            <TopBarMenuDivider />
            {loading && <LoadingIcon />}
            {!loading && (
              <p style={{ fontSize: '0.875rem', color: '#3e3f42', padding: '0 15px' }}>
                {loadList ? loadList.length : '0'} Loads
              </p>
            )}
            {/* Views disabled */}
            <div
              style={{
                display: 'flex',
                marginLeft: 'auto',
                alignItems: 'center'
              }}
            >
              {/* <UikSelect
                className="loadViewSelect"
                defaultValue={['default']}
                options={[
                  { value: 'default', label: view('Default') },
                  {
                    value: 'backup',
                    label: view('Backup')
                  }
                ]}
                onChange={e => setLoadView(e.value)}
                position="bottomRight"
              /> */}
              {haulDetail && haulDetail.project.procoreProjectId && (
                <div className="tooltip">
                  <StyledSyncIconButton onClick={handleProcoreSync} />
                  <span className="tooltiptext" style={{ fontSize: '0.875rem' }}>
                    Procore Sync
                  </span>
                </div>
              )}
              <div className="tooltip">
                <DownloadIconButton onClick={csvExport} />

                <span className="tooltiptext" style={{ fontSize: '0.875rem' }}>
                  CSV
                </span>
              </div>
            </div>
          </TopBarSection>
        </WidgetContent>

        {loadView === 'default' && (
          <TableSection>
            <thead>
              <tr>
                {[
                  'DATE',
                  '#',
                  'PICK-UP',
                  'DROP-OFF',
                  'DRIVER',
                  'TRUCK',
                  'VOLUME',
                  'MATERIAL',
                  ''
                ].map(item => (
                  <TableHeader title={item} key={item} />
                ))}
              </tr>
            </thead>
            <tbody>
              {!loading && !loadingLoads ? (
                // eslint-disable-next-line
                loadList
                  .map((load, i) => {
                    if (
                      i !== 0 &&
                      moment(load.arriveTimeA).format('MMM DD') ===
                        moment(loadList[i - 1].arriveTimeA).format('MMM DD')
                    ) {
                      count++
                    } else {
                      count = 1
                    }
                    if (
                      // i !== 0 &&
                      i !== loadList.length - 1 &&
                      moment(load.arriveTimeA).format('MMM DD') !==
                        moment(loadList[i + 1].arriveTimeA).format('MMM DD')
                    ) {
                      displayDate = true
                    } else if (i === loadList.length - 1) {
                      displayDate = true
                    } else {
                      displayDate = false
                    }
                    return (
                      <LoadItem
                        load={load}
                        i={count}
                        editLoadModalToggle={editLoadModalToggle}
                        key={load._id}
                        haulDetail={haulDetail}
                        viewNotesModalToggle={viewNotesModalToggle}
                        deleteLoad={handleDeleteLoadModal}
                        displayDate={displayDate}
                        handleEditLoad={handleEditLoad}
                        companyId={props.companyId}
                      />
                    )
                  })
                  .reverse()
              ) : (
                <tr></tr>
              )}
            </tbody>
          </TableSection>
        )}

        {loadView === 'backup' && material !== 'concrete' && (
          <TableSection>
            <thead>
              <tr>
                {['#', 'TIME', 'TICKET', 'COMPANY', 'LOCATION', 'GROSS', 'TARE', 'NET', ''].map(
                  item => (
                    <TableHeader title={item} />
                  )
                )}
              </tr>
            </thead>
            <tbody>
              {/* {!loading ? (
                loadList.map((load, i) => (
                  <LoadItemBackup
                    load={load}
                    i={i}
                    editLoadSlipModalToggle={editLoadSlipModalToggle}
                    key={load._id}
                  />
                ))
              ) : (
                <tr></tr>
              )} */}
            </tbody>
          </TableSection>
        )}

        {loadView === 'backup' && material === 'concrete' && (
          <TableSection>
            <thead>
              <tr>
                {[
                  '#',
                  'TIME',
                  'TICKET',
                  'COMPANY',
                  'TRUCK ID',
                  'BATCH SIZE',
                  'TOTAL SHIPPED',
                  ''
                ].map(item => (
                  <TableHeader title={item} />
                ))}
              </tr>
            </thead>
            <tbody>
              {!loading ? (
                loadList.map((load, i) => (
                  <LoadItem
                    load={load}
                    i={i}
                    editLoadModalToggle={editLoadModalToggle}
                    key={load._id}
                    companyId={props.companyId}
                  />
                ))
              ) : (
                <tr></tr>
              )}
            </tbody>
          </TableSection>
        )}
      </TableContainer>
      {editLoadModal && (
        <EditLoadModal
          editLoadDetail={editLoadDetail}
          editLoadModalToggle={editLoadModalToggle}
          editLoad={editLoad}
          materialList={props.materialsList}
          haulList={props.haulList}
          companyId={props.companyId}
        />
      )}

      {/* {editLoadSlipModal && (
        <EditLoadSlipModal
          editLoadSlipModalToggle={editLoadSlipModalToggle}
          editLoadSlipDetail={editLoadSlipDetail}
          editLoad={editLoad}
        />
      )} */}
      {/* {editLoadModalCement && (
        <EditLoadModalCement
          editLoadModalCementToggle={editLoadModalCementToggle}
          editLoadDetail={editLoadDetail}
          editLoad={editLoad}
        />
      )} */}
      {viewNotesModal && (
        <ViewNotesModal handleCloseModal={viewNotesModalToggle} editLoadDetail={editLoadDetail} />
      )}
      {loadActionModal && <LoadActionModal loadAction={loadAction} />}
      {loadDeleteModal && (
        <LoadDeleteModal
          loadDeleteModalToggle={loadDeleteModalToggle}
          loadDeleteDetail={loadDeleteDetail}
          deleteLoad={deleteLoad}
        />
      )}
      {/* {loadMultiUpdateModal && (
        <LoadMultiUpdateModal
          truckType={editLoadDetail.driver.truckType}
          date={multiEditDetail.arriveTimeA}
          loadMultiUpdate={editLoadMulti}
          loadMultiUpdateModalToggle={loadMultiUpdateModalToggle}
          quantity={multiEditDetail.quantity}
        />
      )} */}
      {modalVisible && (
        <SmBannerModal
          heading={procoreError ? 'Sync Loads - Error' : 'Sync Loads'}
          text={
            procoreSyncing
              ? 'Connecting to Procore…'
              : procoreError
              ? 'Error syncing loads'
              : `Successfully synced`
          }
          icon={<SyncIcon />}
          linkText={procoreSyncing ? 'Cancel' : undefined}
          onLinkClick={() => setModalVisible(false)}
          buttonText={!procoreSyncing ? 'Ok' : undefined}
          onButtonClick={() => setModalVisible(false)}
        />
      )}
    </MainContainer>
  )
}

const mapStateToProps = state => {
  return {
    haulList: state.hauls.haulList,
    snackBarCopy: state.ui.snackBarCopy,
    snackBarVisible: state.ui.snackBarVisible,
    materialsList: state.materials.materialList,
    companyId: state.user.userData.companyId,
    projects: state.projects.projectList,
    procore: state.companies.company.procore,
    companyFeatures: state.companies.company.features
  }
}

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      setSnackBarCopy,
      toggleSnackBar,
      getToken
    },
    dispatch
  )

export default connect(mapStateToProps, mapDispatchToProps)(Loads)
